__turbopack_context__.v({
  "inputWrapper": "AlgoliaSearch-module__HOEt-q__inputWrapper",
  "searchDropdown": "AlgoliaSearch-module__HOEt-q__searchDropdown",
  "searchIcon": "AlgoliaSearch-module__HOEt-q__searchIcon",
  "searchbox": "AlgoliaSearch-module__HOEt-q__searchbox",
  "searchboxMobile": "AlgoliaSearch-module__HOEt-q__searchboxMobile",
  "searchinput": "AlgoliaSearch-module__HOEt-q__searchinput",
});
